import { gql } from '@apollo/client';


//variables:{badgeId:1a820426-a831-4a8a-9782-d943dddeaeca}
export const GET_BADGE = gql`
query Badge($badgeId: UUID!) {
  badge(badgeID: $badgeId) {
    badgeId
    name
    description
    isPublished
    image
    isRepeatable
    personBadgeCount
    locales {
      code
      name
      description
    }
  }
}`;

export const CREATE_BADGE = gql`
mutation CreateBadge($input: CreateBadgeInput!) {
  createBadge(input: $input) {
    badgeId
    name
    description
    image
    isRepeatable
    personBadgeCount
    isPublished
    locales {
      code
      name
      description
    }
  }
}`;

export const PATCH_BADGE = gql`
mutation PatchBadge($input: PatchBadgeInput!) {
  patchBadge(input: $input) {
    badgeId
    name
    isRepeatable
    description
    image
    personBadgeCount
    isPublished
    locales {
      code
      name
      description
    }
  }
}`;

// variables: {input: {badgeId: 1a820426-a831-4a8a-9782-d943dddeaeca}}}'
export const DELETE_BADGE = gql`
mutation DeleteBadge($input: DeleteBadgeInput!) {
  deleteBadge(input: $input) {
    affectedRows
  }
}`;
